import React from "react";

const ContactForm = () => {
  return (
    <div
      className="
        w-[90vw] 
        max-w-md 
        mx-auto 
        px-6 
        py-8 
        bg-gray-800 
        rounded-md 
        mt-16 
        text-center 
        text-white
        box-border
      "
    >
      <h2 className="text-xl font-semibold mb-4">Contact</h2>
      <p className="text-gray-300">
        For questions about the platform, feature requests, or to report a bug, please email us at:
      </p>
      <p className="mt-4 font-medium text-purple-400">
        <a href="mailto:support@yivointel.com">support@yivointel.com</a>
      </p>
    </div>
  );
};

export default ContactForm;
